import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=375a0945"
import script from "./InfoIcon.vue?vue&type=script&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports